import type { ReactElement } from 'react';
import { Div, DivSkeleton } from '@fastnorth/kraken/components/layout';

export const SUB_EVENT_PROGRESS_TABLE_SKELETON_ROW_COUNT = 4;
export const SUB_EVENT_PROGRESS_TABLE_SKELETON_COLUMN_COUNT = 6;

const SubEventProgressTableSkeleton = (): ReactElement => (
  <Div
    className="box-border flex w-full min-w-0 max-w-full flex-col gap-8 rounded-xl border border-border p-6"
    data-testid="sub-event-progress-table-skeleton">
    {Array.from({ length: SUB_EVENT_PROGRESS_TABLE_SKELETON_ROW_COUNT }, (_, rowIndex) => (
      <Div
        key={rowIndex}
        className="grid w-full min-w-0 grid-cols-[minmax(0,1fr)_minmax(0,3fr)_repeat(4,minmax(0,1fr))] gap-x-10"
        data-testid="sub-event-progress-table-skeleton-row">
        {Array.from(
          { length: SUB_EVENT_PROGRESS_TABLE_SKELETON_COLUMN_COUNT },
          (_, columnIndex) => (
            <Div
              key={columnIndex}
              className="min-w-0"
              data-testid="sub-event-progress-table-skeleton-cell">
              <DivSkeleton className="h-6 w-full rounded-md" spacing="0 0" />
            </Div>
          )
        )}
      </Div>
    ))}
  </Div>
);

export default SubEventProgressTableSkeleton;
